import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { CheckCircle, Error, Info, Close, Warning } from "@mui/icons-material/";
import { IconButton, Snackbar, SnackbarContent, Typography } from "@mui/material/";
import { makeStyles } from "@mui/styles";
import { styles } from "./styles";

const useStyles=makeStyles(styles);

export const variantIcon = {
  success: CheckCircle,
  warning: Warning,
  error: Error,
  info: Info,
};

const CustomizedSnackbars = ({ extraClass, extraMessageClass, hideClose, extraStyle, handleClose, message, type, ...other }) => {
  const classes=useStyles();
  const [open, setOpen] = useState(true);
  const onClose = (event, reason) => {
    setOpen(false);
    if (handleClose) handleClose();
  };

  useEffect(()=>{
    setTimeout(() => {
      setOpen(false);
      if (handleClose) handleClose();
    }, 5000);
  },[]); //eslint-disable-line react-hooks/exhaustive-deps
  
  const Icon = variantIcon[type];
  return (
    <div>
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        open={open}
        style={{ position: "fixed", ...extraStyle }}>
        <SnackbarContent
          className={clsx(classes[type], classes.margin, extraClass)}
          classes={{
            message: extraMessageClass,
          }}
          aria-describedby="client-snackbar"
          message={
            <span id="client-snackbar" className={clsx(classes.message)}>
              <Icon className={clsx(classes.icon, classes.iconVariant)} />
              <Typography variant="subtitle1" className={classes.messageText}>
                {message}
              </Typography>
            </span>
          }
          action={
            !hideClose
              ? [
                  <IconButton key="close" aria-label="Close" color="inherit" className={classes.close} onClick={onClose} size="large">
                    <Close className={classes.icon} />
                  </IconButton>,
                ]
              : []
          }
          {...other}
        />
      </Snackbar>
    </div>
  );
};

export default CustomizedSnackbars;
